import type { Policy } from 'policies-api'
import { DDSLine } from 'policies-api'
import { PolicyDomains } from '@/typesTenant/PolicyTypes'
import ShurPolicyTile from '@/components/shur/ShurPolicyTile.vue'
import type { Component } from 'vue'
import MotorPolicyTile from '@/components/motor/MotorPolicyTile.vue'

type DomainMap<A> = {
  [P in keyof A]: PolicyDomains | undefined
}

export const TagMap: Record<PolicyDomains, Component> = {
  [PolicyDomains.SHUR]: ShurPolicyTile,
  [PolicyDomains.MOTOR]: MotorPolicyTile
}

// noinspection GrazieInspection
const dynamicPolicyTileMapping: DomainMap<typeof DDSLine> = {
  /* Motor-Tiles */
  Motor: PolicyDomains.MOTOR,
  TechInsurance: PolicyDomains.MOTOR, //Technische Versicherung (TV) - Firmenkunden (idR nicht im ZCP)

  /* SHUR-Tiles */
  Glass: PolicyDomains.SHUR,
  Household: PolicyDomains.SHUR,
  Building: PolicyDomains.SHUR, //Verbundene Gebäude (VGV) -SHUR (analog Privat-Haftpflichtversicherung)

  Accident: PolicyDomains.SHUR, //Unfall – SHUR (analog Privat-Haftpflichtversicherung)
  Liability: PolicyDomains.SHUR,
  LegalProtection: PolicyDomains.SHUR,

  /* Unmapped-Tiles, see KPTHREE-525 */
  FireIndustry: undefined, //Feuer-Industrie - Firmenkunden (idR nicht im ZCP)
  Transport: undefined, //Transport (TR) - Firmenkunden (idR nicht im ZCP)
  BuildingSaving: undefined, //Bausparen – Nicht im ZCP
  ExternalContract: undefined, //Fremdvertrag Spartentopf – Nicht im ZCP
  Investment: undefined, //Investment – Unbekannt
  CapitalInvestment: undefined, //Kapitalanlage -Unbekannt
  Health: undefined, //Kranken – Nicht im ZCP
  BundledProperty: undefined, // ???,
  Life: undefined
}

/**
 * Get the Vue Component Name for a Policy Type
 * @param policy
 */
export function getSpecificComponentTagNameForPolicy(policy: Policy): {
  showDefaultTile: boolean
  domain?: PolicyDomains
  specificTileTag?: Component
} {
  const policyDomain = getCustomComponentNameFromDdsLines(policy.ddsLines ?? [])
  const tagName = policyDomain ? TagMap[policyDomain] : undefined

  return {
    domain: policyDomain,
    showDefaultTile: false,
    specificTileTag: tagName
  }
}

const onlyDefined = <T>(value: T) => !!value
const lookupFrom =
  <K extends string, V>(record: Record<K, V>) =>
  (key: string): V | undefined =>
    record[key as K]

export function getCustomComponentNameFromDdsLines(
  ddsLines: string[]
): PolicyDomains | undefined {
  const components = ddsLines
    .map(lookupFrom(dynamicPolicyTileMapping))
    .filter(onlyDefined)
  if (new Set(components).size === 1) {
    return components[0]
  } else {
    return undefined
  }
}
